module.exports = __webpack_public_path__ + "img/hezuo.1d6187b7.png";